import {charcoal} from '~libSass/base/_exports.sass';
import {DocumentIcon} from '~library/svg/DocumentIcon';
import {AddPhotosLineIcon} from '~library/svg/AddPhotosLineIcon';
import {MailIcon} from '~library/svg/MailIcon';
import {CardDesignIcon} from '~library/svg/CardDesignIcon';
import {DiagonalLinesIcon} from '~library/svg/DiagonalLinesIcon';
import {RevealIcon} from '~library/svg/RevealIcon';
import {NavButton} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/NavBottom/NavButton';
import {Sections} from '~/CreateFabricInvitation/routes/EventCreateDesign/constants';
import {Tooltip} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Tooltip/Tooltip';
import {UploadButton} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/UploadButton/UploadButton';

export const NavigationButtons = ({
  isUyo,
  isFullDyo,
  isPristineUyo,
  isPremium,
  isScreenExtraLarge,
  isLargishAndUp,
  pristineEnvelopeDesign,
  eventId,
  handleImageUploaded,
  id,
}) => (
  <div className="create-design__nav-bottom__buttons_wrapper">
    <div
      className={`create-design__nav-bottom__panel${isUyo && !isFullDyo ? ' nav-bottom__uyo' : ''}`}
    >
      {isUyo ? (
        <>
          {isPristineUyo ? (
            <UploadButton
              isInNavBottom
              callback={handleImageUploaded}
              editor="image"
              section={Sections.CARD_DESIGN}
              id={id}
              index={id}
            />
          ) : (
            <NavButton
              title="Photo"
              icon={<AddPhotosLineIcon color={charcoal} ratio={0.7} />}
              section={Sections.CARD_DESIGN}
              editor="image"
              disableAutoOpenEditor={isLargishAndUp}
            />
          )}
          {!isFullDyo && (
            <NavButton
              title="Text"
              icon={<DocumentIcon color={charcoal} ratio={1} />}
              section={Sections.CARD_DESIGN}
              editor="text"
              disableAutoOpenEditor={isLargishAndUp}
            />
          )}
        </>
      ) : (
        <NavButton
          title="Text"
          icon={<CardDesignIcon color={charcoal} />}
          section={Sections.CARD_DESIGN}
          editor="text"
          disableAutoOpenEditor={isLargishAndUp}
        />
      )}
      <NavButton
        title={isScreenExtraLarge ? 'Background & Effects' : ['Background', '& Effects']}
        icon={<DiagonalLinesIcon color={charcoal} />}
        section={Sections.BACKGROUND}
        premiumFeature
        isPremium={isPremium}
      />
      <Tooltip
        position="top"
        maxContent
        text="NEW: Make any photo or logo a sticker!"
        centerText
        mobileTextSize={!isLargishAndUp}
        visible={pristineEnvelopeDesign && (!isUyo || isLargishAndUp)}
        dataQaId="premium-features-warning-close"
        color="tanzanite"
        showOnce
        shimmer
        id={`premium-features-warning_${eventId}`}
      >
        <NavButton
          title="Envelope"
          icon={<MailIcon color={charcoal} />}
          section={Sections.ENVELOPE_LINER}
          premiumFeature
          isPremium={isPremium}
        />
      </Tooltip>
      <NavButton
        title="Reveals"
        icon={<RevealIcon color={charcoal} />}
        section={Sections.REVEAL}
        premiumFeature
        isPremium={isPremium}
      />
    </div>
  </div>
);
